const prependZero = dayOrMonth =>
  dayOrMonth < 10
    ? `0${dayOrMonth}`
    : dayOrMonth.toString();

const formatDate = date =>
  `${prependZero(date.getDate())}.${prependZero(date.getMonth() + 1)}.${date.getFullYear()}`;

export default formatDate;
